/**
 * Decisão de UI de loading para Minhas Consultas (paciente).
 * Evita flicker: refetch com dados existentes não desmonta a lista.
 */

export type AppointmentsLoadingView =
  | 'initial'
  | 'refreshing-with-data'
  | 'refreshing-empty'
  | 'idle-with-data'
  | 'idle-empty';

export function resolveAppointmentsLoadingView(params: {
  hasLoadedOnce: boolean;
  isFetching: boolean;
  appointmentsCount: number;
}): AppointmentsLoadingView {
  const count = Math.max(0, params.appointmentsCount || 0);
  const hasData = count > 0;

  if (!params.hasLoadedOnce && params.isFetching) {
    return 'initial';
  }

  if (hasData) {
    return params.isFetching ? 'refreshing-with-data' : 'idle-with-data';
  }

  if (!params.hasLoadedOnce) {
    return params.isFetching ? 'initial' : 'idle-empty';
  }

  return params.isFetching ? 'refreshing-empty' : 'idle-empty';
}

export function shouldShowAppointmentsList(view: AppointmentsLoadingView): boolean {
  return view === 'idle-with-data' || view === 'refreshing-with-data';
}

export function shouldShowFullPageLoader(view: AppointmentsLoadingView): boolean {
  return view === 'initial';
}

export function shouldShowRefreshingIndicator(view: AppointmentsLoadingView): boolean {
  return view === 'refreshing-with-data' || view === 'refreshing-empty';
}
